import React, { Component } from "react";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import {
  Button,

} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

const modalStyle = {
  width: '700px',
  height: '600px',
  marginLeft: '-10%',
  marginTop: '-20%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class AutoCodesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      selectedRows: [],
      currentRow: undefined,
    };
  }

  componentDidMount() {
    const handleInitData = (data) => {
      if (data.length == 0) return
      let rows = data.map((item, index) => {
        return {
          _id: index,
          pack_time: this.timeTOYmdOrMdy(item.package_date, 'mm-dd-yyyy'),
          ProductNum: item.ProductNum,
          ProductRefNum: item.ProductRefNum,
          total_wt: item.RcvTotalWeight,
          prod_wt: parseFloat(item.RcvTotalWeight / item.RcvQuantity).toFixed(2),
          qty: item.RcvQuantity,
          Batch_id: item.Batch_id,
        }
      })
      return rows;
    }
    if (this.props.data) {
      this.setState({
        rows: handleInitData(this.props.data),
        // line: rows,
        pack_time: this.props.data.package_date,
      });
    }
  }

  handlePrintCode = () => {
    let cpSelectedRows = [];
    this.state.selectedRows.map(item => {
      let row = {
        prod_wt: Number(item.prod_wt),
        prod_num: item.ProductNum,
        pack_time: this.timeTOYmdOrMdy(item.pack_time),
        prod_ref: item.prod_ref,
        batch_id: item.Batch_id,
      }
      // for (let i = 0; i < item.qty; i++) {
        cpSelectedRows.push(row)
      // }
    })
    this.props.print(cpSelectedRows)
  }

  timeTOYmdOrMdy = (time, format = 'yyyy-mm-dd') => {
    let timeTo = time;
    if (time.length != 10 || time.indexOf('-') == -1) {
      return timeTo
    }
    if (format == 'yyyy-mm-dd') {// 12-12-2024 -> 2024-12-12
      if (time.length == 10 && time.indexOf('-') != -1) {
        let times = time.split('-');
        if (times[2].length != 4) {
          return timeTo;
        }
        timeTo = `${times[2]}-${times[0]}-${times[1]}`
      }
    }
    if (format == 'mm-dd-yyyy') {// 2024-12-12 -> 12-12-2024
      if (time.length == 10 && time.indexOf('-') != -1) {
        let times = time.split('-');
        if (times[0].length != 4) {
          return timeTo;
        }
        timeTo = `${times[1]}-${times[2]}-${times[0]}`
      }
    }
    return timeTo;
  }

  renderAutoCodesTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state);
    const getSize = () => getRows().length;
    const rowGetter = rowIdx => {
      var rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    }

    const columns = [
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true
      },
      {
        key: 'ProductRefNum',
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true
      },
      {
        key: 'pack_time',
        name: <Translate value="package_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: 'prod_wt',
        name: <Translate value="avg_wt" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'total_wt',
        name: <Translate value="total_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'qty',
        name: <Translate value="qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
      }
    ];

    const handleRowUpdated = (e) => {
      let rows = getRows();
      if (e.updated.prod_wt != null) {
        if (parseFloat(e.updated.prod_wt) < 0) {
          alert('The weight must be greater than 0');
        }
        Object.assign(rows[e.rowIdx], { prod_wt: e.updated.prod_wt });
        this.setState({ rows })
      }
    }

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      let selectedRows = [];
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });

      newRows.map(r => {
        if (r.isSelected === true) {
          selectedRows.push(r);
        }
      });
      this.setState({ ...this.state, selectedRows, rows: newRows })

    };
    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.rows];
      const selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.findIndex(item => item._id == r.row._id);
        selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows });
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        let rows = getRows();
        let selectedRows = [];
        rows.map(rowItem => {
          if (rowItem._id == row._id) {
            if (row.isSelected) {
              return { ...rowItem, isSelected: false };
            }
            selectedRows.push({ ...rowItem, isSelected: true });
            return { ...rowItem, isSelected: true };
          }
          if (rowItem.isSelected) {
            selectedRows.push({ ...rowItem });
          }
          return { ...row }
        })
        rows[rowIdx].isSelected = true;
        this.setState({ rows, selectedRows: [...this.state.selectedRows] });
      }
    };

    const onCellSelected = (row) => {
      const rows = getRows();
      let selectedRows = [];
      rows.map(rowItem => {
        if (rowItem._id == row.rowIdx) {
          if (rowItem.isSelected) {
            return { ...rowItem, isSelected: false };
          }
          selectedRows.push({ ...rowItem, isSelected: true });
          return { ...rowItem, isSelected: true };
        }
        if (rowItem.isSelected) {
          selectedRows.push({ ...rowItem });
        }
        return { ...row }
      })
      rows[row.rowIdx].isSelected = true;
      this.setState({ rows, selectedRows: [...this.state.selectedRows] });
    };

    return (
      <ReactDataGrid
        rowKey='autoCode'
        enableCellSelect={true}
        rowGetter={rowGetter}
        headerRowHeight={45}
        rowHeight={25}
        rowsCount={getSize()}
        columns={columns}
        onRowUpdated={handleRowUpdated}
        minHeight={450}
        enableRowSelect="multi"
        rowSelection={{
          showCheckbox: true,
          onRowsSelected,
          onRowsDeselected,
          selectBy: {
            isSelectedKey: 'isSelected',
          },
        }}
        onRowClick={onRowClick}
        onCellSelected={onCellSelected}
      />
    )
  }

  render() {

    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'start', alignContent: 'end', textAlign: 'end', alignItems: 'end', paddingBottom: '10px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            style={{ marginLeft: 10 }}
            disabled={this.state.selectedRows.length == 0 || this.state.selectedRows.findIndex(item => !item.ProductNum) != -1}
            onClick={this.handlePrintCode}
          >
            <Translate value="print" />
          </Button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '350px', border: '1px olid red' }}>
          {this.renderAutoCodesTable()}
        </div>
      </div>
    )
  }
}

const AutoCodesModal = ({ setModalVisibility, isVisible, data, print }) => (
  <SkyLightStateless
    title={<Translate value="long_codes" />}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <AutoCodesList data={data} isVisible={isVisible} print={print} />
  </SkyLightStateless>
)

AutoCodesModal.propTypes = propTypes
AutoCodesModal.defaultProps = defaultProps

export default AutoCodesModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/AutoCodesModal.jsx